export const TICKET_PRIORITY_OPTIONS = [
    'Critical',
    'High',
    'Medium',
    'Low',
];

export const TICKET_STATUS_OPTIONS = [
    'Created',
    'Resolved',
];

export const TICKET_CATEGORY_OPTIONS = [
    'Technical',
    'Product',
    'Refund',
    'Order'
];

export const TICKET_TABS_LIST = [
    { label: "Active Tickets", ticketStatus: "Created" },
    { label: "Resolved Tickets", ticketStatus: "Resolved" },
];